"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeIcon = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classNameBuilders_1 = require("../../../lib/classNameBuilders");
const setDisplayName_1 = (0, tslib_1.__importDefault)(require("../../../lib/setDisplayName"));
const getDisplayname_1 = require("../../../lib/getDisplayname");
const makeIcon = (name) => {
    return (IconComponent) => {
        const Icon = (props) => {
            const { className } = props, rest = (0, tslib_1.__rest)(props, ["className"]);
            return ((0, jsx_runtime_1.jsx)(IconComponent, Object.assign({ className: (0, classNameBuilders_1.classnames)("icon", `icon--${name}`, className) }, rest), void 0));
        };
        return (0, setDisplayName_1.default)(`Icon(${(0, getDisplayname_1.getDisplayName)(IconComponent)})`)(Icon);
    };
};
exports.makeIcon = makeIcon;
//# sourceMappingURL=makeIcon.js.map